import { useMemo } from "react"

import { useParams } from "@Components/RouterProvider"
import createStore from "@Stores/base-factories"
import { hookPublisherList, hookSubIdList } from "@Stores/base-factories/store-list"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useTransactionFactory = () => {
  const { id } = useParams()

  return useMemo(() => ({ collectionsURL: id ? `allocation/${id}/transactions` : null }), [id])
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('site_id'))
  .extend(useTransactionFactory)
  .extendHookCollectionsFactory()
  .extend(hookPublisherList())
  .extend(hookSubIdList())
  .factory()

export {
  Provider as TransactionProvider,
  useStore as useTransactionStore,
}
